module.exports = __webpack_public_path__ + "img/approve@2x.9af63406.png";